export default {
  allowPhysicianRegistration: true,
  showPhysicians: true,
  showRealtors: false,
  posthogProjectToken: 'phc_vXFk38hWHSNKXHvmrMKAhkDgbUMZmoBCSSQjCWRgxB8Y',
}
